import { AbstractInvoice } from './abstract-invoice';

export class CreditNote extends AbstractInvoice { }
